import { CheckCircle2, CircleDashed, type LucideIcon, UserRoundCog } from 'lucide-react';

import type { ConversationResult } from '@/schemas/commons';

import type { ResultLabelKey } from './ResultPill.types';

/** Every state pairs its color with an icon so the meaning never rests on color alone. */
export const RESULT_STYLE: Record<
	ConversationResult,
	{ icon: LucideIcon; className: string; labelKey: ResultLabelKey }
> = {
	resolved: { icon: CheckCircle2, className: 'bg-surface-success text-success', labelKey: 'RESULT_RESOLVED' },
	handoff: { icon: UserRoundCog, className: 'bg-surface-info text-info', labelKey: 'RESULT_HANDOFF' },
	open: { icon: CircleDashed, className: 'bg-surface-warning text-warning', labelKey: 'RESULT_OPEN' },
};
